import Vue from 'vue'
import App from './App.vue'
import router from "./router";

Vue.config.productionTip = false

//路由
import VueRouter from 'vue-router'
Vue.use(VueRouter)

//材料设计语言组件库 vuetify
// import Vuetify from 'vuetify'
// import 'vuetify/dist/vuetify.min.css'
// Vue.use(Vuetify)

//材料设计语言组件库 vue-material
import { MdButton, MdCard} from 'vue-material/dist/components'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
Vue.use(MdButton)
Vue.use(MdCard)

//element组件库
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI)

//iview组件库
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
Vue.use(ViewUI)

//vant 组件库
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

//axios
import axios from "axios"; 
Vue.use(axios);
Vue.prototype.$axios = axios;

 
new Vue({
  el: "#app",
  router,
  render: h => h(App)
});